// Mock data for Metal Solutions website

export const company = {
  name: "METAL SOLUTIONS S.R.L.",
  shortName: "Metal Solutions",
  address: "Via Cal Morganella 19/E",
  city: "31038 Paese (TV)",
  country: "Italia",
  vat: "05587690263",
  cf: "05587690263",
  tel: "+39 351 9647825",
  telRaw: "+393519647825",
  email: "metalsolutionsita@gmail.com",
  warehouse: {
    label: "Magazzino e Deposito",
    address: "Via Napoleone Zardo 24",
    city: "31017 Pieve del Grappa (TV)",
  },
};

export const heroSlides = [
  {
    id: 1,
    eyebrow: "Forniture per professionisti",
    title: "L'e-commerce di Metal Solutions",
    subtitle: "Ferramenta, Utensileria e Antinfortunistica",
    description:
      "Da specialisti per rivenditori, imprese e operatori del settore. Forniture rapide e sicure su tutto il territorio nazionale.",
    cta: "SCOPRI TUTTI I PRODOTTI",
    ctaLink: "/prodotti",
    image:
      "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: 2,
    eyebrow: "Materiale Ferroso",
    title: "Commercio di materiale ferroso",
    subtitle: "Acciaio, profilati e laminati",
    description:
      "Forniamo materiale ferroso di qualità per cantieri, officine e aziende manifatturiere con consegne tempestive.",
    cta: "SCOPRI DI PIÙ",
    ctaLink: "/prodotti",
    image:
      "https://images.unsplash.com/photo-1697698532634-ea59b636ccea?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: 3,
    eyebrow: "Servizi su misura",
    title: "Manutenzione, Pulizia, Portierato",
    subtitle: "Facchinaggio e gestione logistica",
    description:
      "Un partner unico per i servizi tecnici e operativi della tua azienda. Team qualificato e copertura territoriale completa.",
    cta: "I NOSTRI SERVIZI",
    ctaLink: "/servizi",
    image:
      "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
];

export const categories = [
  {
    name: "Ferramenta",
    slug: "ferramenta",
    image:
      "https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    sub: [
      "Viterie e bulloneria",
      "Fissaggio chimico",
      "Tasselli e ancoraggi",
      "Catene e funi",
      "Serrature e cilindri",
      "Cerniere e accessori",
      "Maniglie e pomoli",
      "Articoli per porte e finestre",
    ],
  },
  {
    name: "Utensileria",
    slug: "utensileria",
    image:
      "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    sub: [
      "Utensili manuali",
      "Avvitatori e trapani",
      "Smerigliatrici angolari",
      "Punte e frese",
      "Saldatrici e accessori",
      "Misurazione e tracciatura",
      "Banchi e cassettiere",
      "Aspirapolvere industriali",
    ],
  },
  {
    name: "Antinfortunistica (DPI)",
    slug: "antinfortunistica",
    image:
      "https://images.unsplash.com/photo-1662309376159-b95fb193d96b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    sub: [
      "Guanti da lavoro",
      "Calzature di sicurezza",
      "Protezione vie respiratorie",
      "Protezione udito",
      "Protezione occhi",
      "Protezione anticaduta",
      "Abbigliamento da lavoro",
      "Pronto soccorso",
    ],
  },
  {
    name: "Materiale Ferroso",
    slug: "materiale-ferroso",
    image:
      "https://images.unsplash.com/photo-1501166222995-ff31c7e93cef?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    sub: [
      "Tondini in acciaio",
      "Profilati IPE / HEA",
      "Lamiere zincate",
      "Tubolari",
      "Reti elettrosaldate",
      "Angolari",
      "Travi in acciaio",
      "Acciaio inox",
    ],
  },
  {
    name: "Manutenzione e Pulizia",
    slug: "manutenzione-pulizia",
    image:
      "https://images.pexels.com/photos/6195274/pexels-photo-6195274.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=900",
    sub: [
      "Pulizia industriale",
      "Manutenzione impianti",
      "Idropulitrici",
      "Detergenti professionali",
      "Igiene industriale",
      "Sanificazione",
      "Carte e accessori",
      "Saponi e creme lavamani",
    ],
  },
  {
    name: "Portierato e Facchinaggio",
    slug: "portierato-facchinaggio",
    image:
      "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=900",
    sub: [
      "Servizio di portineria",
      "Reception aziendale",
      "Facchinaggio interno",
      "Movimentazione merci",
      "Carico e scarico",
      "Traslochi industriali",
      "Gestione magazzino",
      "Logistica fiere",
    ],
  },
];

export const services = [
  {
    title: "Manutenzione Industriale",
    icon: "Wrench",
    description:
      "Servizi di manutenzione ordinaria e straordinaria per impianti, macchinari e strutture aziendali.",
  },
  {
    title: "Pulizia Professionale",
    icon: "Sparkles",
    description:
      "Pulizia di uffici, capannoni industriali e aree comuni con prodotti professionali e personale qualificato.",
  },
  {
    title: "Portierato",
    icon: "ShieldCheck",
    description:
      "Servizio di reception, controllo accessi e gestione visitatori per aziende e complessi industriali.",
  },
  {
    title: "Facchinaggio",
    icon: "PackageOpen",
    description:
      "Movimentazione, carico/scarico e gestione completa della logistica interna del tuo magazzino.",
  },
];

export const catalogs = [
  {
    id: 1,
    title: "Catalogo Ferramenta 2025",
    pages: 320,
    cover:
      "https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  },
  {
    id: 2,
    title: "Catalogo Utensileria",
    pages: 245,
    cover:
      "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  },
  {
    id: 3,
    title: "DPI & Antinfortunistica",
    pages: 180,
    cover:
      "https://images.unsplash.com/photo-1662309376159-b95fb193d96b?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  },
  {
    id: 4,
    title: "Materiale Ferroso",
    pages: 96,
    cover:
      "https://images.unsplash.com/photo-1501166222995-ff31c7e93cef?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  },
];

export const news = [
  {
    id: 1,
    date: "15 Giugno 2025",
    category: "Novità",
    title: "Nuova linea di calzature antinfortunistiche disponibile",
    excerpt:
      "Ampliamo la nostra gamma con calzature S3 di ultima generazione, comfort e protezione massimi per il tuo team.",
    image:
      "https://images.unsplash.com/photo-1651499910684-b6b82c2da504?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: 2,
    date: "02 Giugno 2025",
    category: "Promozioni",
    title: "Sconti speciali su utensili elettrici professionali",
    excerpt:
      "Fino al 30% di sconto sulla linea di avvitatori e trapani professionali fino al 30 giugno.",
    image:
      "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: 3,
    date: "18 Maggio 2025",
    category: "Azienda",
    title: "Apertura del nuovo deposito a Pieve del Grappa",
    excerpt:
      "Ampliamo la nostra capacità logistica con il nuovo deposito di Via Napoleone Zardo per consegne ancora più rapide.",
    image:
      "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const stats = [
  { value: "15+", label: "Anni di esperienza" },
  { value: "10.000+", label: "Articoli a catalogo" },
  { value: "500+", label: "Clienti attivi" },
  { value: "24/48h", label: "Tempi di consegna" },
];
